import NachWrapper from '../components/NachWrapper';
import Filter from './filter/Index';

function WebhookDashboard() {
  return (
    <NachWrapper
      title="NACH Webhook Dashboard"
      className=" col-xs-12 col-sm-12 col-md-12"
      style={{ marginLeft: '15px' }}
    >
      <Filter />
    </NachWrapper>
  );
}

export default WebhookDashboard;
